import { merge } from '~/_v3/common/domain/imm';

import type { NavigationContext } from './navigation.machine';

export const setPayslipAgreementStatus = ({ context, event }: { context: NavigationContext; event: any }) => {
	return merge(context, { canSelectAgreement: event.output.canSelectAgreement });
};
